import { createSlice } from "@reduxjs/toolkit";
import { TOKEN_KEY, USER_KEY } from "../../services";

const readUser = () => {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY));
  } catch {
    return null;
  }
};

const token = localStorage.getItem(TOKEN_KEY) || "";

// A saved token is only a hint: the app asks the server who this is before showing anything
const initialState = {
  token,
  user: token ? readUser() : null,
  checking: Boolean(token),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.checking = false;
      localStorage.setItem(TOKEN_KEY, action.payload.token);
      localStorage.setItem(USER_KEY, JSON.stringify(action.payload.user));
    },
    setUser: (state, action) => {
      state.user = action.payload;
      state.checking = false;
      localStorage.setItem(USER_KEY, JSON.stringify(action.payload));
    },
    setToken: (state, action) => {
      state.token = action.payload;
      localStorage.setItem(TOKEN_KEY, action.payload);
    },
    logout: (state) => {
      state.token = "";
      state.user = null;
      state.checking = false;
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
    },
  },
});

export const { loginSuccess, setUser, setToken, logout } = authSlice.actions;
export const selectUser = (state) => state.auth.user;
export const selectChecking = (state) => state.auth.checking;

export default authSlice.reducer;
